import axios from 'axios'
import { ApiConfig } from '../../config/api'
import { ScanType } from './types'

const scanParamKey: Record<ScanType, string> = {
  ASN: 'asnNumber',
  LPN: 'lpn',
  SKU: 'sku'
}

// Busca ASNs por escaneo (ASN / LPN / SKU)
export const searchAsnReception = (scanType: ScanType, scanValue: string) => {
  const url = new URL(`${ApiConfig.AsnReceptionLpnApi}`)
  url.searchParams.set(scanParamKey[scanType], scanValue)
  url.searchParams.set('pageSize', '20')
  return axios.get(url.toString())
}

// Busca ASNs por proveedor
export const searchBySupplier = (supplierId: number) => {
  const url = new URL(`${ApiConfig.AsnReceptionLpnApi}`)
  url.searchParams.set('supplierId', supplierId.toString())
  url.searchParams.set('pageSize', '20')
  return axios.get(url.toString())
}

// Busca ASNs por origen de proveedor
export const searchBySupplierOrigin = (supplierOriginId: number) => {
  const url = new URL(`${ApiConfig.AsnReceptionLpnApi}`)
  url.searchParams.set('supplierOriginId', supplierOriginId.toString())
  url.searchParams.set('pageSize', '20')
  return axios.get(url.toString())
}

// Busca ASNs por marca
export const searchByBrand = (brandId: number) => {
  const url = new URL(`${ApiConfig.AsnReceptionLpnApi}`)
  url.searchParams.set('brandId', brandId.toString())
  url.searchParams.set('pageSize', '20')
  return axios.get(url.toString())
}

// Obtiene el detalle de una ASN con sus LPNs
export const getAsnReceptionLpnInfo = (asnId: number) =>
  axios.get(`${ApiConfig.AsnReceptionLpnApi}/${asnId}`)

// Recepciona las LPNs escaneadas
export const receiveAsnLpns = (asnId: number, lpns: string[]) =>
  axios.patch(`${ApiConfig.AsnReceptionLpnApi}/Receive/${asnId}`, lpns.map((lpn) => ({ lpn })))

// Busca ASNs por almacén
export const searchByWarehouse = (warehouseId: number) => {
  const url = new URL(`${ApiConfig.AsnReceptionLpnApi}`)
  url.searchParams.set('warehouseId', warehouseId.toString())
  url.searchParams.set('pageSize', '20')
  return axios.get(url.toString())
}
